export default __webpack_public_path__ + "static/media/corner-bottom-left.047f063e.png";